/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deals_AssigneeInputs */

const cs_deals_assignee = /** @type {(inputs: Deals_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Makléř`)
};

const en_deals_assignee = /** @type {(inputs: Deals_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assignee`)
};

/**
* | output |
* | --- |
* | "Assignee" |
*
* @param {Deals_AssigneeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deals_assignee = /** @type {((inputs?: Deals_AssigneeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deals_AssigneeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deals_assignee(inputs)
	return cs_deals_assignee(inputs)
});